@use '../../design-tokens/typography/typography' as *;

@layer design-system {
  .container {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  .priceContainer {
    display: flex;
    align-items: baseline;
    gap: 8px;

    &.isPrimary .price {
      @include typography-v2-title-lg;
    }

    &:not(.isPrimary) .price {
      @include typography-v2-title-md;

      line-height: 1.75rem;
    }
  }

  .priceAndCurrencyContainer {
    display: flex;
    gap: 4px;
    align-items: baseline;
  }

  .price {
    font-family: var(--font-roboto-mono);
  }

  .currency {
    @include typography-v2-body-xs;

    text-transform: uppercase;
    color: var(--text-soft);
  }

  .priceChangeContainer {
    display: flex;
    gap: 8px;
    font-family: var(--font-roboto-mono);

    @include typography-v2-body-xs;

    &.default {
      color: var(--text-soft);
    }

    &.negative {
      color: var(--viz-bearish);
    }

    &.positive {
      color: var(--viz-bullish);
    }
  }

  .priceChangeLabel {
    font-family: var(--font-roboto-mono);

    @include typography-v2-body-sm;
  }

  .percentageChangeLabel {
    font-family: var(--font-roboto-mono);

    @include typography-v2-body-sm;
  }

  .labelsContainer {
    display: flex;
  }

  .liveLabel {
    color: var(--text-success);

    @include typography-v2-body-sm;
  }

  .outsideHoursTag {
    @include typography-v2-body-sm;

    margin-right: 12px;

    &.pre {
      color: var(--text-primary);
    }

    &.after {
      color: var(--text-soft);
    }
  }
}
